import { createFileRoute } from "@tanstack/react-router"
import OrderDetail from "@/pages/account/order-detail"

export const Route = createFileRoute("/$countryCode/account/orders/$orderId")({
  head: () => ({
    meta: [
      { title: "Order details | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: OrderDetail,
})
